import classes from "./PlansAndCredits.module.scss";
import {
  plansAndCreditsHeroListItems,
  plansAndCreditsHeroPlans,
  plansAndCreditsWaysToSpend,
} from "./plansAndCreditsData";
import { useTranslation } from "react-i18next";
import CustomButton from "../../components/ui/CustomButton/CustomButton";
import featureImage01 from "../../assets/images/plans-and-credits/feature-01.png";
import featureImage02 from "../../assets/images/plans-and-credits/feature-02.png";
import { useNavigate } from "react-router";

const PlansAndCredits = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={classes["page"]}>
      <section className={classes["hero"]}>
        <div className="container">
          <h1 className={classes["title"]}>{t("ChooseAPlanThatBestYourLifestyle")}</h1>
          <div className={classes["wrapper"]}>
            {plansAndCreditsHeroPlans.map((item) => {
              return (
                <div key={item.id} className={classes["item"]}>
                  <p>
                    {item.numberOfCredits} <span>{t("Credits")}</span>
                  </p>
                  <h3>
                    €{item.price}/ <span>{t("Month")}</span>
                  </h3>
                  <div className={classes["btn-wrapper"]}>
                    <CustomButton text={t("Get7DaysFree")} type={"button"} typeStyle={"fill"} />
                  </div>
                </div>
              );
            })}
          </div>
          <div className={classes["list"]}>
            {plansAndCreditsHeroListItems.map((item) => {
              return (
                <div key={item} className={classes["item"]}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_29310_23545)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M25.1364 5.96267C25.4645 6.29084 25.6488 6.73588 25.6488 7.19992C25.6488 7.66395 25.4645 8.10899 25.1364 8.43717L12.0195 21.554C11.8462 21.7274 11.6404 21.8649 11.4139 21.9588C11.1874 22.0526 10.9446 22.1009 10.6995 22.1009C10.4543 22.1009 10.2115 22.0526 9.98502 21.9588C9.75852 21.8649 9.55272 21.7274 9.37938 21.554L2.86238 15.0382C2.69524 14.8767 2.56192 14.6836 2.4702 14.4701C2.37849 14.2566 2.33021 14.027 2.32819 13.7946C2.32617 13.5623 2.37045 13.3318 2.45844 13.1167C2.54643 12.9017 2.67638 12.7063 2.84069 12.542C3.005 12.3777 3.20039 12.2477 3.41546 12.1597C3.63053 12.0717 3.86097 12.0275 4.09333 12.0295C4.3257 12.0315 4.55533 12.0798 4.76884 12.1715C4.98234 12.2632 5.17545 12.3965 5.33688 12.5637L10.6989 17.9257L22.6607 5.96267C22.8232 5.80005 23.0162 5.67104 23.2286 5.58303C23.441 5.49501 23.6686 5.44971 23.8985 5.44971C24.1285 5.44971 24.3561 5.49501 24.5685 5.58303C24.7809 5.67104 24.9739 5.80005 25.1364 5.96267Z"
                        fill="#18181B"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_29310_23545">
                        <rect width="28" height="28" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  {t(item)}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className={classes["banner"]}>
        <div className="container">
          <h2 className={classes["title"]}>{t("WhatAreTheCredits")}</h2>
          <p
            className={classes["subtitle"]}
            dangerouslySetInnerHTML={{ __html: t("ClubPassCreditsAllowYouToBook") }}
            style={{ maxWidth: "850px" }}
          ></p>
          <p className={classes["subtitle"]} style={{ maxWidth: "715px" }}>
            {t("UseThemHoweverYouLike")}
          </p>
        </div>
      </section>

      <section className={classes["ways-to-spend"]}>
        <div className="container">
          <div className={classes["wrapper"]}>
            {plansAndCreditsWaysToSpend.map((item) => {
              return (
                <div className={classes["item"]}>
                  <h3>{item.id}</h3>
                  <p>{t(item.text)}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className={classes["feature"]} style={{ background: "#FAFAFA" }}>
        <div className="container">
          <div className={`${classes["wrapper"]}`}>
            <div className={classes["item"]}>
              <h2>{t("SaveWithTheMembership")}</h2>
              <p
                dangerouslySetInnerHTML={{ __html: t("ClubPassGivesYouExclusiveMemberRates") }}
              ></p>
              <div className={classes["btn-wrapper"]}>
                <CustomButton text={t("Get7DaysFree")} type={"button"} typeStyle={"fill"} />
              </div>
            </div>
            <div className={`${classes["item"]} ${classes["image"]}`}>
              <img src={featureImage01} alt={"feature-01"} />
            </div>
          </div>
        </div>
      </section>

      <section className={classes["feature"]}>
        <div className="container">
          <div className={`${classes["wrapper"]} ${classes["reverse"]}`}>
            <div className={classes["item"]}>
              <h2>{t("WantToGetSomeMorePerks")}</h2>
              <p dangerouslySetInnerHTML={{ __html: t("ReferAFriendToJoinClubPassBySharing") }}></p>
              <div className={classes["btn-wrapper"]}>
                <CustomButton
                  text={t("LearnMore")}
                  type={"button"}
                  typeStyle={"fill"}
                  functionOnClick={() => navigate("/plans-and-credits/learn-more")}
                />
              </div>
            </div>
            <div className={`${classes["item"]} ${classes["image"]}`}>
              <img src={featureImage02} alt={"feature-02"} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PlansAndCredits;
